import request from "@/utils/request";  //导入封装请求的js文件

export function detail() {
  return request({
    url: "/memberApi/user/detail",  //接口路径
    method: "get",  //接口方法
  });
}

export function editUser(data) {
  return request({
    url: "/memberApi/user/editUser",  //接口路径
    method: "put",  //接口方法
    data  //接口参数
  });
}

//修改密码
export function uPassword(data) {
  return request({
    url: "/memberApi/user/uPassword",  //接口路径
    method: "put",  //接口方法
    data  //接口参数
  });
}

// 修改手机号
export function modifyPhone(data) {
  return request({
    url: "/memberApi/user/modifyPhone",  //接口路径
    method: "post",  //接口方法
    data  //接口参数
  });
}

